{
  "tencentcloud.ami": {
    "columns": [
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image ID"
      },
      {
        "type": "string",
        "field": "OsName",
        "headerName": "OS Name"
      },
      {
        "type": "string",
        "field": "ImageType",
        "headerName": "Image Type"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "string",
        "field": "ImageName",
        "headerName": "Image Name"
      },
      {
        "type": "string",
        "field": "ImageDescription",
        "headerName": "Image Description"
      },
      {
        "type": "number",
        "field": "ImageSize",
        "headerName": "Image Size"
      },
      {
        "type": "string",
        "field": "Architecture",
        "headerName": "Architecture"
      },
      {
        "type": "string",
        "field": "ImageState",
        "headerName": "Image State"
      },
      {
        "type": "string",
        "field": "Platform",
        "headerName": "Platform"
      },
      {
        "type": "string",
        "field": "ImageCreator",
        "headerName": "Image Creator"
      },
      {
        "type": "string",
        "field": "ImageSource",
        "headerName": "Image Source"
      },
      {
        "type": "number",
        "field": "SyncPercent",
        "headerName": "Sync Percent"
      },
      {
        "type": "boolean",
        "field": "IsSupportCloudinit",
        "headerName": "Is Support Cloudinit"
      },
      {
        "type": "string",
        "field": "LicenseType",
        "headerName": "License Type"
      }
    ],
    "id": "ImageId"
  },
  "tencentcloud.cam-policy": {
    "columns": [
      {
        "type": "number",
        "field": "PolicyId",
        "headerName": "Policy ID"
      },
      {
        "type": "string",
        "field": "PolicyName",
        "headerName": "Policy Name"
      },
      {
        "type": "time",
        "field": "AddTime",
        "headerName": "Add Time"
      },
      {
        "type": "number",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "string",
        "field": "Description",
        "headerName": "Description"
      },
      {
        "type": "number",
        "field": "CreateMode",
        "headerName": "Create Mode"
      },
      {
        "type": "number",
        "field": "Attachments",
        "headerName": "Attachments"
      },
      {
        "type": "string",
        "field": "ServiceType",
        "headerName": "Service Type"
      },
      {
        "type": "number",
        "field": "IsAttached",
        "headerName": "Is Attached"
      },
      {
        "type": "number",
        "field": "Deactived",
        "headerName": "Deactivated"
      },
      {
        "type": "array",
        "field": "DeactivedDetail",
        "headerName": "Deactivated Detail"
      },
      {
        "type": "number",
        "field": "IsServiceLinkedPolicy",
        "headerName": "Is Service Linked Policy"
      },
      {
        "type": "number",
        "field": "AttachEntityCount",
        "headerName": "Attach Entity Count"
      },
      {
        "type": "number",
        "field": "AttachEntityBoundaryCount",
        "headerName": "Attach Entity Boundary Count"
      },
      {
        "type": "time",
        "field": "UpdateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "PolicyId"
  },
  "tencentcloud.cam-user": {
    "columns": [
      {
        "type": "number",
        "field": "Uin",
        "headerName": "UIN"
      },
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "number",
        "field": "Uid",
        "headerName": "UID"
      },
      {
        "type": "string",
        "field": "Remark",
        "headerName": "Remark"
      },
      {
        "type": "number",
        "field": "ConsoleLogin",
        "headerName": "Console Login"
      },
      {
        "type": "string",
        "field": "PhoneNum",
        "headerName": "Phone Number"
      },
      {
        "type": "string",
        "field": "CountryCode",
        "headerName": "Country Code"
      },
      {
        "type": "string",
        "field": "Email",
        "headerName": "Email"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "NickName",
        "headerName": "Nick Name"
      }
    ],
    "id": "Uin"
  },
  "tencentcloud.cbs": {
    "columns": [
      {
        "type": "string",
        "field": "DiskId",
        "headerName": "Id"
      }
    ],
    "id": "DiskId"
  },
  "tencentcloud.cbs-snapshot": {
    "columns": [
      {
        "type": "string",
        "field": "Placement.Zone",
        "headerName": "Zone"
      },
      {
        "type": "string",
        "field": "Placement.CageId",
        "headerName": "Cage ID"
      },
      {
        "type": "number",
        "field": "Placement.ProjectId",
        "headerName": "Project ID"
      },
      {
        "type": "string",
        "field": "Placement.CdcName",
        "headerName": "CDC Name"
      },
      {
        "type": "string",
        "field": "Placement.CdcId",
        "headerName": "CDC ID"
      },
      {
        "type": "string",
        "field": "Placement.DedicatedClusterId",
        "headerName": "Dedicated Cluster ID"
      },
      {
        "type": "boolean",
        "field": "CopyFromRemote",
        "headerName": "Copy from Remote"
      },
      {
        "type": "string",
        "field": "SnapshotState",
        "headerName": "Snapshot State"
      },
      {
        "type": "boolean",
        "field": "IsPermanent",
        "headerName": "Is Permanent"
      },
      {
        "type": "string",
        "field": "SnapshotName",
        "headerName": "Snapshot Name"
      },
      {
        "type": "time",
        "field": "DeadlineTime",
        "headerName": "Deadline Time"
      },
      {
        "type": "number",
        "field": "Percent",
        "headerName": "Percent"
      },
      {
        "type": "number",
        "field": "ShareReference",
        "headerName": "Share Reference"
      },
      {
        "type": "string",
        "field": "SnapshotType",
        "headerName": "Snapshot Type"
      },
      {
        "type": "number",
        "field": "DiskSize",
        "headerName": "Disk Size"
      },
      {
        "type": "string",
        "field": "DiskId",
        "headerName": "Disk ID"
      },
      {
        "type": "array",
        "field": "CopyingToRegions",
        "headerName": "Copying to Regions"
      },
      {
        "type": "boolean",
        "field": "Encrypt",
        "headerName": "Encrypt"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "number",
        "field": "ImageCount",
        "headerName": "Image Count"
      },
      {
        "type": "string",
        "field": "DiskUsage",
        "headerName": "Disk Usage"
      },
      {
        "type": "string",
        "field": "SnapshotId",
        "headerName": "Snapshot ID"
      },
      {
        "type": "time",
        "field": "TimeStartShare",
        "headerName": "Time Start Share"
      }
    ],
    "id": "SnapshotId"
  },
  "tencentcloud.clb": {
    "columns": [
      {
        "type": "string",
        "field": "LoadBalancerId",
        "headerName": "Id"
      }
    ],
    "id": "LoadBalancerId"
  },
  "tencentcloud.cls": {
    "columns": [
      {
        "type": "string",
        "field": "TopicId",
        "headerName": "Id"
      }
    ],
    "id": "TopicId"
  },
  "tencentcloud.cos": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "string",
        "field": "Location",
        "headerName": "Location"
      },
      {
        "type": "time",
        "field": "CreationDate",
        "headerName": "Creation Date"
      },
      {
        "type": "string",
        "field": "BucketType",
        "headerName": "Bucket Type"
      }
    ],
    "id": "Name"
  },
  "tencentcloud.cvm": {
    "columns": [
      {
        "type": "string",
        "field": "Placement.Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "Placement.ProjectId",
        "headerName": "Project ID"
      },
      {
        "type": "array",
        "field": "Placement.HostIds",
        "headerName": "Host IDs"
      },
      {
        "type": "string",
        "field": "Placement.HostId",
        "headerName": "Host ID"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance ID"
      },
      {
        "type": "string",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "CPU",
        "headerName": "CPU"
      },
      {
        "type": "number",
        "field": "Memory",
        "headerName": "Memory"
      },
      {
        "type": "string",
        "field": "RestrictState",
        "headerName": "Restrict State"
      },
      {
        "type": "string",
        "field": "InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "string",
        "field": "InstanceChargeType",
        "headerName": "Instance Charge Type"
      },
      {
        "type": "string",
        "field": "SystemDisk.DiskType",
        "headerName": "System Disk Type"
      },
      {
        "type": "string",
        "field": "SystemDisk.DiskId",
        "headerName": "System Disk ID"
      },
      {
        "type": "number",
        "field": "SystemDisk.DiskSize",
        "headerName": "System Disk Size"
      },
      {
        "type": "string",
        "field": "SystemDisk.CdcId",
        "headerName": "System Disk CDC ID"
      },
      {
        "type": "array",
        "field": "PrivateIpAddresses",
        "headerName": "Private IP Addresses"
      },
      {
        "type": "array",
        "field": "PublicIpAddresses",
        "headerName": "Public IP Addresses"
      },
      {
        "type": "string",
        "field": "InternetAccessible.InternetChargeType",
        "headerName": "Internet Charge Type"
      },
      {
        "type": "number",
        "field": "InternetAccessible.InternetMaxBandwidthOut",
        "headerName": "Internet Max Bandwidth Out"
      },
      {
        "type": "boolean",
        "field": "InternetAccessible.PublicIpAssigned",
        "headerName": "Public IP Assigned"
      },
      {
        "type": "string",
        "field": "InternetAccessible.BandwidthPackageId",
        "headerName": "Bandwidth Package ID"
      },
      {
        "type": "string",
        "field": "VirtualPrivateCloud.VpcId",
        "headerName": "VPC ID"
      },
      {
        "type": "string",
        "field": "VirtualPrivateCloud.SubnetId",
        "headerName": "Subnet ID"
      },
      {
        "type": "boolean",
        "field": "VirtualPrivateCloud.AsVpcGateway",
        "headerName": "Is VPC Gateway"
      },
      {
        "type": "array",
        "field": "VirtualPrivateCloud.PrivateIpAddresses",
        "headerName": "VPC Private IP Addresses"
      },
      {
        "type": "number",
        "field": "VirtualPrivateCloud.Ipv6AddressCount",
        "headerName": "IPv6 Address Count"
      },
      {
        "type": "string",
        "field": "ImageId",
        "headerName": "Image ID"
      },
      {
        "type": "string",
        "field": "RenewFlag",
        "headerName": "Renew Flag"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "time",
        "field": "ExpiredTime",
        "headerName": "Expired Time"
      },
      {
        "type": "string",
        "field": "OsName",
        "headerName": "OS Name"
      },
      {
        "type": "array",
        "field": "SecurityGroupIds",
        "headerName": "Security Group IDs"
      },
      {
        "type": "string",
        "field": "LoginSettings.Password",
        "headerName": "Login Password"
      },
      {
        "type": "array",
        "field": "LoginSettings.KeyIds",
        "headerName": "Login Key IDs"
      },
      {
        "type": "string",
        "field": "LoginSettings.KeepImageLogin",
        "headerName": "Keep Image Login"
      },
      {
        "type": "string",
        "field": "InstanceState",
        "headerName": "Instance State"
      },
      {
        "type": "string",
        "field": "StopChargingMode",
        "headerName": "Stop Charging Mode"
      },
      {
        "type": "string",
        "field": "Uuid",
        "headerName": "UUID"
      },
      {
        "type": "string",
        "field": "LatestOperation",
        "headerName": "Latest Operation"
      },
      {
        "type": "string",
        "field": "LatestOperationState",
        "headerName": "Latest Operation State"
      },
      {
        "type": "string",
        "field": "LatestOperationRequestId",
        "headerName": "Latest Operation Request ID"
      },
      {
        "type": "string",
        "field": "DisasterRecoverGroupId",
        "headerName": "Disaster Recover Group ID"
      },
      {
        "type": "array",
        "field": "IPv6Addresses",
        "headerName": "IPv6 Addresses"
      },
      {
        "type": "string",
        "field": "CamRoleName",
        "headerName": "CAM Role Name"
      },
      {
        "type": "string",
        "field": "HpcClusterId",
        "headerName": "HPC Cluster ID"
      },
      {
        "type": "array",
        "field": "RdmaIpAddresses",
        "headerName": "RDMA IP Addresses"
      },
      {
        "type": "string",
        "field": "IsolatedSource",
        "headerName": "Isolated Source"
      },
      {
        "type": "number",
        "field": "GPUInfo.GPUCount",
        "headerName": "GPU Count"
      },
      {
        "type": "array",
        "field": "GPUInfo.GPUId",
        "headerName": "GPU ID"
      },
      {
        "type": "string",
        "field": "GPUInfo.GPUType",
        "headerName": "GPU Type"
      },
      {
        "type": "string",
        "field": "LicenseType",
        "headerName": "License Type"
      },
      {
        "type": "boolean",
        "field": "DisableApiTermination",
        "headerName": "Disable API Termination"
      },
      {
        "type": "string",
        "field": "DefaultLoginUser",
        "headerName": "Default Login User"
      },
      {
        "type": "number",
        "field": "DefaultLoginPort",
        "headerName": "Default Login Port"
      },
      {
        "type": "string",
        "field": "LatestOperationErrorMsg",
        "headerName": "Latest Operation Error Message"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.dns-record": {
    "columns": [
      {
        "type": "string",
        "field": "DomainId",
        "headerName": "Id"
      }
    ],
    "id": "DomainId"
  },
  "tencentcloud.eip": {
    "columns": [
      {
        "type": "string",
        "field": "AddressId",
        "headerName": "Id"
      }
    ],
    "id": "AddressId"
  },
  "tencentcloud.elasticsearch": {
    "columns": [
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance ID"
      },
      {
        "type": "string",
        "field": "InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "string",
        "field": "Region",
        "headerName": "Region"
      },
      {
        "type": "string",
        "field": "Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "AppId",
        "headerName": "App ID"
      },
      {
        "type": "string",
        "field": "Uin",
        "headerName": "UIN"
      },
      {
        "type": "string",
        "field": "VpcUid",
        "headerName": "VPC UID"
      },
      {
        "type": "string",
        "field": "SubnetUid",
        "headerName": "Subnet UID"
      },
      {
        "type": "number",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "RenewFlag",
        "headerName": "Renew Flag"
      },
      {
        "type": "string",
        "field": "ChargeType",
        "headerName": "Charge Type"
      },
      {
        "type": "number",
        "field": "ChargePeriod",
        "headerName": "Charge Period"
      },
      {
        "type": "string",
        "field": "NodeType",
        "headerName": "Node Type"
      },
      {
        "type": "number",
        "field": "NodeNum",
        "headerName": "Node Count"
      },
      {
        "type": "number",
        "field": "CpuNum",
        "headerName": "CPU Count"
      },
      {
        "type": "number",
        "field": "MemSize",
        "headerName": "Memory Size"
      },
      {
        "type": "string",
        "field": "DiskType",
        "headerName": "Disk Type"
      },
      {
        "type": "number",
        "field": "DiskSize",
        "headerName": "Disk Size"
      },
      {
        "type": "string",
        "field": "EsDomain",
        "headerName": "ES Domain"
      },
      {
        "type": "string",
        "field": "EsVip",
        "headerName": "ES VIP"
      },
      {
        "type": "number",
        "field": "EsPort",
        "headerName": "ES Port"
      },
      {
        "type": "string",
        "field": "KibanaUrl",
        "headerName": "Kibana URL"
      },
      {
        "type": "string",
        "field": "EsVersion",
        "headerName": "ES Version"
      },
      {
        "type": "string",
        "field": "EsConfig",
        "headerName": "ES Config"
      },
      {
        "type": "array",
        "field": "EsAcl.BlackIpList",
        "headerName": "Denied IPs"
      },
      {
        "type": "array",
        "field": "EsAcl.WhiteIpList",
        "headerName": "Allowed IPs"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "time",
        "field": "UpdateTime",
        "headerName": "Update Time"
      },
      {
        "type": "string",
        "field": "Deadline",
        "headerName": "Deadline"
      },
      {
        "type": "number",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "string",
        "field": "IkConfig.UpdateType",
        "headerName": "IK Update Type"
      },
      {
        "type": "boolean",
        "field": "MasterNodeInfo.EnableDedicatedMaster",
        "headerName": "Dedicated Master Enabled"
      },
      {
        "type": "string",
        "field": "MasterNodeInfo.MasterNodeType",
        "headerName": "Master Node Type"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeNum",
        "headerName": "Master Node Count"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeCpuNum",
        "headerName": "Master Node CPU Count"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeMemSize",
        "headerName": "Master Node Memory Size"
      },
      {
        "type": "number",
        "field": "MasterNodeInfo.MasterNodeDiskSize",
        "headerName": "Master Node Disk Size"
      },
      {
        "type": "string",
        "field": "MasterNodeInfo.MasterNodeDiskType",
        "headerName": "Master Node Disk Type"
      },
      {
        "type": "boolean",
        "field": "CosBackup.IsAutoBackup",
        "headerName": "COS Auto Backup"
      },
      {
        "type": "time",
        "field": "CosBackup.BackupTime",
        "headerName": "COS Backup Time"
      },
      {
        "type": "boolean",
        "field": "AllowCosBackup",
        "headerName": "Allow COS Backup"
      },
      {
        "type": "string",
        "field": "LicenseType",
        "headerName": "License Type"
      },
      {
        "type": "boolean",
        "field": "EnableHotWarmMode",
        "headerName": "Enable Hot Warm Mode"
      },
      {
        "type": "string",
        "field": "WarmNodeType",
        "headerName": "Warm Node Type"
      },
      {
        "type": "number",
        "field": "WarmNodeNum",
        "headerName": "Warm Node Count"
      },
      {
        "type": "number",
        "field": "WarmCpuNum",
        "headerName": "Warm CPU Count"
      },
      {
        "type": "number",
        "field": "WarmMemSize",
        "headerName": "Warm Memory Size"
      },
      {
        "type": "string",
        "field": "WarmDiskType",
        "headerName": "Warm Disk Type"
      },
      {
        "type": "number",
        "field": "WarmDiskSize",
        "headerName": "Warm Disk Size"
      },
      {
        "type": "string",
        "field": "EsPublicUrl",
        "headerName": "ES Public URL"
      },
      {
        "type": "number",
        "field": "DeployMode",
        "headerName": "Deploy Mode"
      },
      {
        "type": "string",
        "field": "PublicAccess",
        "headerName": "Public Access"
      },
      {
        "type": "array",
        "field": "EsPublicAcl.BlackIpList",
        "headerName": "Public Denied IPs"
      },
      {
        "type": "array",
        "field": "EsPublicAcl.WhiteIpList",
        "headerName": "Public Allowed IPs"
      },
      {
        "type": "string",
        "field": "KibanaPrivateUrl",
        "headerName": "Kibana Private URL"
      },
      {
        "type": "string",
        "field": "KibanaPublicAccess",
        "headerName": "Kibana Public Access"
      },
      {
        "type": "string",
        "field": "KibanaPrivateAccess",
        "headerName": "Kibana Private Access"
      },
      {
        "type": "number",
        "field": "SecurityType",
        "headerName": "Security Type"
      },
      {
        "type": "number",
        "field": "SceneType",
        "headerName": "Scene Type"
      },
      {
        "type": "string",
        "field": "KibanaConfig",
        "headerName": "Kibana Config"
      },
      {
        "type": "string",
        "field": "KibanaNodeInfo.KibanaNodeType",
        "headerName": "Kibana Node Type"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeNum",
        "headerName": "Kibana Node Count"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeCpuNum",
        "headerName": "Kibana Node CPU Count"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeMemSize",
        "headerName": "Kibana Node Memory Size"
      },
      {
        "type": "string",
        "field": "KibanaNodeInfo.KibanaNodeDiskType",
        "headerName": "Kibana Node Disk Type"
      },
      {
        "type": "number",
        "field": "KibanaNodeInfo.KibanaNodeDiskSize",
        "headerName": "Kibana Node Disk Size"
      },
      {
        "type": "number",
        "field": "WebNodeTypeInfo.NodeNum",
        "headerName": "Web Node Count"
      },
      {
        "type": "string",
        "field": "WebNodeTypeInfo.NodeType",
        "headerName": "Web Node Type"
      },
      {
        "type": "string",
        "field": "Jdk",
        "headerName": "JDK"
      },
      {
        "type": "string",
        "field": "Protocol",
        "headerName": "Protocol"
      },
      {
        "type": "array",
        "field": "SecurityGroups",
        "headerName": "Security Groups"
      },
      {
        "type": "string",
        "field": "ColdNodeType",
        "headerName": "Cold Node Type"
      },
      {
        "type": "number",
        "field": "ColdNodeNum",
        "headerName": "Cold Node Count"
      },
      {
        "type": "number",
        "field": "ColdCpuNum",
        "headerName": "Cold CPU Count"
      },
      {
        "type": "number",
        "field": "ColdMemSize",
        "headerName": "Cold Memory Size"
      },
      {
        "type": "string",
        "field": "ColdDiskType",
        "headerName": "Cold Disk Type"
      },
      {
        "type": "number",
        "field": "ColdDiskSize",
        "headerName": "Cold Disk Size"
      },
      {
        "type": "string",
        "field": "FrozenNodeType",
        "headerName": "Frozen Node Type"
      },
      {
        "type": "number",
        "field": "FrozenNodeNum",
        "headerName": "Frozen Node Count"
      },
      {
        "type": "number",
        "field": "FrozenCpuNum",
        "headerName": "Frozen CPU Count"
      },
      {
        "type": "number",
        "field": "FrozenMemSize",
        "headerName": "Frozen Memory Size"
      },
      {
        "type": "string",
        "field": "FrozenDiskType",
        "headerName": "Frozen Disk Type"
      },
      {
        "type": "number",
        "field": "FrozenDiskSize",
        "headerName": "Frozen Disk Size"
      },
      {
        "type": "number",
        "field": "HealthStatus",
        "headerName": "Health Status"
      },
      {
        "type": "string",
        "field": "EsPrivateUrl",
        "headerName": "ES Private URL"
      },
      {
        "type": "string",
        "field": "EsPrivateDomain",
        "headerName": "ES Private Domain"
      },
      {
        "type": "array",
        "field": "OperationDuration.Periods",
        "headerName": "Maintenance Days"
      },
      {
        "type": "time",
        "field": "OperationDuration.TimeStart",
        "headerName": "Maintenance Start"
      },
      {
        "type": "time",
        "field": "OperationDuration.TimeEnd",
        "headerName": "Maintenance End"
      },
      {
        "type": "string",
        "field": "OperationDuration.TimeZone",
        "headerName": "Maintenance Time Zone"
      },
      {
        "type": "boolean",
        "field": "AutoIndexEnabled",
        "headerName": "Auto Index Enabled"
      },
      {
        "type": "boolean",
        "field": "EnableHybridStorage",
        "headerName": "Enable Hybrid Storage"
      },
      {
        "type": "number",
        "field": "ProcessPercent",
        "headerName": "Process Percent"
      },
      {
        "type": "string",
        "field": "KibanaAlteringPublicAccess",
        "headerName": "Kibana Altering Public Access"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.mysql": {
    "columns": [
      {
        "type": "number",
        "field": "WanStatus",
        "headerName": "WAN Status"
      },
      {
        "type": "string",
        "field": "Zone",
        "headerName": "Zone"
      },
      {
        "type": "number",
        "field": "InitFlag",
        "headerName": "Init Flag"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoVipStatus",
        "headerName": "Read Only VIP Status"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoSubnetId",
        "headerName": "Read Only Subnet ID"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoVpcId",
        "headerName": "Read Only VPC ID"
      },
      {
        "type": "number",
        "field": "RoVipInfo.RoVport",
        "headerName": "Read Only Port"
      },
      {
        "type": "string",
        "field": "RoVipInfo.RoVip",
        "headerName": "Read Only VIP"
      },
      {
        "type": "number",
        "field": "Memory",
        "headerName": "Memory"
      },
      {
        "type": "number",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "number",
        "field": "VpcId",
        "headerName": "VPC ID"
      },
      {
        "type": "number",
        "field": "SlaveInfo.First.Vport",
        "headerName": "First Replica Port"
      },
      {
        "type": "string",
        "field": "SlaveInfo.First.Region",
        "headerName": "First Replica Region"
      },
      {
        "type": "string",
        "field": "SlaveInfo.First.Vip",
        "headerName": "First Replica VIP"
      },
      {
        "type": "string",
        "field": "SlaveInfo.First.Zone",
        "headerName": "First Replica Zone"
      },
      {
        "type": "number",
        "field": "SlaveInfo.Second.Vport",
        "headerName": "Second Replica Port"
      },
      {
        "type": "string",
        "field": "SlaveInfo.Second.Region",
        "headerName": "Second Replica Region"
      },
      {
        "type": "string",
        "field": "SlaveInfo.Second.Vip",
        "headerName": "Second Replica VIP"
      },
      {
        "type": "string",
        "field": "SlaveInfo.Second.Zone",
        "headerName": "Second Replica Zone"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance ID"
      },
      {
        "type": "number",
        "field": "Volume",
        "headerName": "Volume"
      },
      {
        "type": "number",
        "field": "AutoRenew",
        "headerName": "Auto Renew"
      },
      {
        "type": "number",
        "field": "ProtectMode",
        "headerName": "Protect Mode"
      },
      {
        "type": "number",
        "field": "SubnetId",
        "headerName": "Subnet ID"
      },
      {
        "type": "number",
        "field": "InstanceType",
        "headerName": "Instance Type"
      },
      {
        "type": "number",
        "field": "ProjectId",
        "headerName": "Project ID"
      },
      {
        "type": "string",
        "field": "Region",
        "headerName": "Region"
      },
      {
        "type": "time",
        "field": "DeadlineTime",
        "headerName": "Deadline Time"
      },
      {
        "type": "number",
        "field": "DeployMode",
        "headerName": "Deploy Mode"
      },
      {
        "type": "number",
        "field": "TaskStatus",
        "headerName": "Task Status"
      },
      {
        "type": "string",
        "field": "MasterInfo.Region",
        "headerName": "Master Region"
      },
      {
        "type": "number",
        "field": "MasterInfo.RegionId",
        "headerName": "Master Region ID"
      },
      {
        "type": "number",
        "field": "MasterInfo.ZoneId",
        "headerName": "Master Zone ID"
      },
      {
        "type": "string",
        "field": "MasterInfo.Zone",
        "headerName": "Master Zone"
      },
      {
        "type": "string",
        "field": "MasterInfo.InstanceId",
        "headerName": "Master Instance ID"
      },
      {
        "type": "string",
        "field": "MasterInfo.ResourceId",
        "headerName": "Master Resource ID"
      },
      {
        "type": "number",
        "field": "MasterInfo.Status",
        "headerName": "Master Status"
      },
      {
        "type": "string",
        "field": "MasterInfo.InstanceName",
        "headerName": "Master Instance Name"
      },
      {
        "type": "number",
        "field": "MasterInfo.InstanceType",
        "headerName": "Master Instance Type"
      },
      {
        "type": "number",
        "field": "MasterInfo.TaskStatus",
        "headerName": "Master Task Status"
      },
      {
        "type": "number",
        "field": "MasterInfo.Memory",
        "headerName": "Master Memory"
      },
      {
        "type": "number",
        "field": "MasterInfo.Volume",
        "headerName": "Master Volume"
      },
      {
        "type": "string",
        "field": "MasterInfo.DeviceType",
        "headerName": "Master Device Type"
      },
      {
        "type": "number",
        "field": "MasterInfo.Qps",
        "headerName": "Master QPS"
      },
      {
        "type": "number",
        "field": "MasterInfo.VpcId",
        "headerName": "Master VPC ID"
      },
      {
        "type": "number",
        "field": "MasterInfo.SubnetId",
        "headerName": "Master Subnet ID"
      },
      {
        "type": "string",
        "field": "MasterInfo.ExClusterId",
        "headerName": "Master Dedicated Cluster ID"
      },
      {
        "type": "string",
        "field": "MasterInfo.ExClusterName",
        "headerName": "Master Dedicated Cluster Name"
      },
      {
        "type": "string",
        "field": "DeviceType",
        "headerName": "Device Type"
      },
      {
        "type": "string",
        "field": "EngineVersion",
        "headerName": "Engine Version"
      },
      {
        "type": "string",
        "field": "InstanceName",
        "headerName": "Instance Name"
      },
      {
        "type": "string",
        "field": "WanDomain",
        "headerName": "WAN Domain"
      },
      {
        "type": "number",
        "field": "WanPort",
        "headerName": "WAN Port"
      },
      {
        "type": "number",
        "field": "PayType",
        "headerName": "Pay Type"
      },
      {
        "type": "time",
        "field": "CreateTime",
        "headerName": "Create Time"
      },
      {
        "type": "string",
        "field": "Vip",
        "headerName": "VIP"
      },
      {
        "type": "number",
        "field": "Vport",
        "headerName": "Vport"
      },
      {
        "type": "number",
        "field": "CdbError",
        "headerName": "CDB Error"
      },
      {
        "type": "string",
        "field": "UniqVpcId",
        "headerName": "Unique VPC ID"
      },
      {
        "type": "string",
        "field": "UniqSubnetId",
        "headerName": "Unique Subnet ID"
      },
      {
        "type": "string",
        "field": "PhysicalId",
        "headerName": "Physical ID"
      },
      {
        "type": "number",
        "field": "Cpu",
        "headerName": "CPU"
      },
      {
        "type": "number",
        "field": "Qps",
        "headerName": "QPS"
      },
      {
        "type": "string",
        "field": "ZoneName",
        "headerName": "Zone Name"
      },
      {
        "type": "string",
        "field": "DeviceClass",
        "headerName": "Device Class"
      },
      {
        "type": "string",
        "field": "DeployGroupId",
        "headerName": "Deploy Group ID"
      },
      {
        "type": "number",
        "field": "ZoneId",
        "headerName": "Zone ID"
      },
      {
        "type": "number",
        "field": "InstanceNodes",
        "headerName": "Instance Nodes"
      },
      {
        "type": "string",
        "field": "EngineType",
        "headerName": "Engine Type"
      },
      {
        "type": "number",
        "field": "MaxDelayTime",
        "headerName": "Max Delay Time"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.mysql-backup": {
    "columns": [
      {
        "type": "string",
        "field": "Name",
        "headerName": "Name"
      },
      {
        "type": "number",
        "field": "Size",
        "headerName": "Size"
      },
      {
        "type": "time",
        "field": "Date",
        "headerName": "Date"
      },
      {
        "type": "string",
        "field": "IntranetUrl",
        "headerName": "Intranet URL"
      },
      {
        "type": "string",
        "field": "InternetUrl",
        "headerName": "Internet URL"
      },
      {
        "type": "string",
        "field": "Type",
        "headerName": "Type"
      },
      {
        "type": "number",
        "field": "BackupId",
        "headerName": "Backup ID"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "time",
        "field": "FinishTime",
        "headerName": "Finish Time"
      },
      {
        "type": "string",
        "field": "Creator",
        "headerName": "Creator"
      },
      {
        "type": "time",
        "field": "StartTime",
        "headerName": "Start Time"
      },
      {
        "type": "string",
        "field": "Method",
        "headerName": "Method"
      },
      {
        "type": "string",
        "field": "Way",
        "headerName": "Way"
      },
      {
        "type": "string",
        "field": "ManualBackupName",
        "headerName": "Manual Backup Name"
      },
      {
        "type": "string",
        "field": "SaveMode",
        "headerName": "Save Mode"
      },
      {
        "type": "string",
        "field": "Region",
        "headerName": "Region"
      },
      {
        "type": "number",
        "field": "CosStorageType",
        "headerName": "COS Storage Type"
      },
      {
        "type": "string",
        "field": "InstanceId",
        "headerName": "Instance ID"
      },
      {
        "type": "string",
        "field": "EncryptionFlag",
        "headerName": "Encryption Flag"
      }
    ],
    "id": "InstanceId"
  },
  "tencentcloud.nat-gateway": {
    "columns": [
      {
        "type": "string",
        "field": "NatGatewayId",
        "headerName": "NAT Gateway ID"
      },
      {
        "type": "string",
        "field": "NatGatewayName",
        "headerName": "NAT Gateway Name"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "string",
        "field": "State",
        "headerName": "State"
      },
      {
        "type": "number",
        "field": "InternetMaxBandwidthOut",
        "headerName": "Internet Max Bandwidth Out"
      },
      {
        "type": "number",
        "field": "MaxConcurrentConnection",
        "headerName": "Max Concurrent Connection"
      },
      {
        "type": "string",
        "field": "NetworkState",
        "headerName": "Network State"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "VPC ID"
      },
      {
        "type": "string",
        "field": "Zone",
        "headerName": "Zone"
      },
      {
        "type": "array",
        "field": "DirectConnectGatewayIds",
        "headerName": "Direct Connect Gateway IDs"
      },
      {
        "type": "string",
        "field": "SubnetId",
        "headerName": "Subnet ID"
      },
      {
        "type": "array",
        "field": "SecurityGroupSet",
        "headerName": "Security Group Set"
      },
      {
        "type": "boolean",
        "field": "IsExclusive",
        "headerName": "Is Exclusive"
      },
      {
        "type": "number",
        "field": "ExclusiveGatewayBandwidth",
        "headerName": "Exclusive Gateway Bandwidth"
      },
      {
        "type": "string",
        "field": "RestrictState",
        "headerName": "Restrict State"
      }
    ],
    "id": "NatGatewayId"
  },
  "tencentcloud.security-group": {
    "columns": [
      {
        "type": "string",
        "field": "SecurityGroupId",
        "headerName": "Security Group ID"
      },
      {
        "type": "string",
        "field": "SecurityGroupName",
        "headerName": "Security Group Name"
      },
      {
        "type": "string",
        "field": "SecurityGroupDesc",
        "headerName": "Security Group Description"
      },
      {
        "type": "string",
        "field": "ProjectId",
        "headerName": "Project ID"
      },
      {
        "type": "boolean",
        "field": "IsDefault",
        "headerName": "Is Default"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "time",
        "field": "UpdateTime",
        "headerName": "Update Time"
      }
    ],
    "id": "SecurityGroupId"
  },
  "tencentcloud.subnet": {
    "columns": [
      {
        "type": "string",
        "field": "SubnetId",
        "headerName": "Id"
      }
    ],
    "id": "SubnetId"
  },
  "tencentcloud.tcr": {
    "columns": [
      {
        "type": "string",
        "field": "RegistryId",
        "headerName": "Registry ID"
      },
      {
        "type": "string",
        "field": "RegistryName",
        "headerName": "Registry Name"
      },
      {
        "type": "string",
        "field": "RegistryType",
        "headerName": "Registry Type"
      },
      {
        "type": "string",
        "field": "Status",
        "headerName": "Status"
      },
      {
        "type": "string",
        "field": "PublicDomain",
        "headerName": "Public Domain"
      },
      {
        "type": "string",
        "field": "CreatedAt",
        "headerName": "Created At"
      },
      {
        "type": "string",
        "field": "RegionName",
        "headerName": "Region Name"
      },
      {
        "type": "number",
        "field": "RegionId",
        "headerName": "Region ID"
      },
      {
        "type": "boolean",
        "field": "EnableAnonymous",
        "headerName": "Enable Anonymous"
      },
      {
        "type": "number",
        "field": "TokenValidTime",
        "headerName": "Token Valid Time"
      },
      {
        "type": "string",
        "field": "InternalEndpoint",
        "headerName": "Internal Endpoint"
      },
      {
        "type": "string",
        "field": "TagSpecification.ResourceType",
        "headerName": "Tagged Resource Type"
      },
      {
        "type": "string",
        "field": "ExpiredAt",
        "headerName": "Expired At"
      },
      {
        "type": "number",
        "field": "PayMod",
        "headerName": "Pay Mode"
      },
      {
        "type": "number",
        "field": "RenewFlag",
        "headerName": "Renew Flag"
      }
    ],
    "id": "RegistryId"
  },
  "tencentcloud.vpc": {
    "columns": [
      {
        "type": "string",
        "field": "VpcName",
        "headerName": "VPC Name"
      },
      {
        "type": "string",
        "field": "VpcId",
        "headerName": "VPC ID"
      },
      {
        "type": "string",
        "field": "CidrBlock",
        "headerName": "CIDR Block"
      },
      {
        "type": "boolean",
        "field": "IsDefault",
        "headerName": "Is Default"
      },
      {
        "type": "boolean",
        "field": "EnableMulticast",
        "headerName": "Enable Multicast"
      },
      {
        "type": "time",
        "field": "CreatedTime",
        "headerName": "Created Time"
      },
      {
        "type": "array",
        "field": "DnsServerSet",
        "headerName": "DNS Server Set"
      },
      {
        "type": "string",
        "field": "DomainName",
        "headerName": "Domain Name"
      },
      {
        "type": "string",
        "field": "DhcpOptionsId",
        "headerName": "DHCP Options ID"
      },
      {
        "type": "boolean",
        "field": "EnableDhcp",
        "headerName": "Enable DHCP"
      },
      {
        "type": "string",
        "field": "Ipv6CidrBlock",
        "headerName": "IPv6 CIDR Block"
      }
    ],
    "id": "VpcId"
  }
}
